import React, { useState } from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import FotosessionLinks from './FotosessionLinks';
import axios from 'axios';
import './App.css';
import cu from './utils/clientUtils';
  
function App() {
  const [message, setMessage] = useState("");

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

const fetchCsrfToken = async () => {
  let token = localStorage.getItem("psrft");
  if (token) return token;

  const response = await axios.get("/api/csrf-token");
  token = response.data.csrfToken;

  localStorage.setItem("psrft", token);
  return token;
};

  const handleSendMessage =  async (event) => {
    event.preventDefault();
    setMessage("");

    try {
      const csrfToken = await fetchCsrfToken();
      const kt = cu.gk(csrfToken);
      const response = await axios.post(
        "/api/sendMessage", 
        {message},
        {headers: {"X-CSRF-Token": csrfToken, "X-PERS-Key": kt.k, "X-PERS-T":  kt.t}}
      );

      console.log('Response:', response.data);
      alert("Thanks for contacting us! Your message was sent.")
    } catch (error) {
      console.error('Error submitting question:', error);
    }
  };

  return (
  <BrowserRouter>
      <Routes>
        <Route path="/mv/foto" element = {<FotosessionLinks /> }/>
        <Route path="/" element = {
          <div className="App">
            <header className="App-header">
              <h1>Personote!</h1>
              <h4><i>Sorry!!!! The functionality is still under development. Please check it out later...</i></h4>

            </header>
            <div className="App-body">
              <h3>Menawhile you can contact us:</h3>
              <form className="App-Content" onSubmit={handleSendMessage}>
                <input
                  className="App-Content"
                  type="text"
                  placeholder="Please enter a message."
                  value={message}
                  onChange={handleMessageChange}
                />
                <button className="App-Content" type="submit">Send!</button>
              </form>
            </div>
          </div> }
        />
      </Routes>
  </BrowserRouter>
);
}

export default App;
